import React from "react";
import Me from "../../assets/me.jpg";

const About = (props) => {
  const { setContactSelected } = props;

  return (
    <section className="about-container">
      <div>
        <p>
          I am a data analytics professional with a background in full-stack development and a strong focus on data 
          modeling, analytics, and data-driven decision making. My work centers on transforming raw data into reliable,
          well-structured datasets that support analysis, reporting, and predictive modeling.
        </p>
        <p>
          Through academic and applied projects, I have developed experience building ETL pipelines,
          designing relational data models, performing exploratory data analysis, and developing machine
            learning models for both regression and classification use cases. I am particularly interested
          in analytical workflows that bridge technical implementation with real-world business and operational questions.
        </p>
        <p>
          My technical background spans SQL and PostgreSQL data modeling, Python-based analysis, data visualization,
          and dashboarding, with additional experience in software engineering concepts from prior full-stack
          development work. This combination allows me to collaborate effectively across technical and non-technical
          teams while maintaining strong attention to data quality, structure, and reproducibility. 
        </p>
        <p>
          I am seeking opportunities in data analytics, business intelligence, or analytics engineering where I can
          contribute to building trustworthy data foundations and delivering actionable insights. 
        </p>
        <p>TECHNICAL SKILLS:</p>
        <ul className="stack-list">
          <li>Data & Analytics: SQL (PostgreSQL), Data Modeling (Star Schema), Exploratory Data Analysis (EDA), Data Quality & Validation</li>
          <li>Programming & Tools: Python, pandas, scikit-learn, psycopg2, Jupyter Notebook</li>
          <li>Visualization & BI: Tableau, matplotlib, Dashboard Design</li>
          <li>Data Engineering Concepts: ETL Pipelines, Feature Engineering, Reproducible Workflows</li>
          <li>Software & Platforms: Git/GitHub, React (foundational), REST APIs (foundational)</li>
        </ul>
        <p>EDUCATION:</p>
        <ul>
          <li>
            Bachelor of Science, Data Analytics<br/>
            Associate of Applied Science<br/>
            Certificate, Full Stack Web Development<br/>
            </li>
        </ul>
      </div>
      <div>
      <img src={Me} className="selfie" alt="ProfessionalJason" />
      </div>
    </section>
  );
};

export default About;